// extracted by mini-css-extract-plugin
export default {"root":"root--D2WcG","approved":"approved--CQq1f","pending":"pending--LeWVm","rejected":"rejected--jJk_z","started":"started--K74cR"};